const version = "2.8.0";

export { version };
//# sourceMappingURL=version.mjs.map
